import EditRosterWrapper from "../common/EditRosterWrapper";

function EditRoster() {
  return <EditRosterWrapper rosterType="primary" />;
}

export default EditRoster;
